import { Button } from "../../../../../design/button";
import { Field, Label } from "../../../../../design/fieldset";
import OnboardingContainer from "../../../components/OnboardingContainer";
import { Select } from "../../../../../design/select";
import {
  RelationshipStatus,
  relationshipStatusArray,
} from "../../../../../models/RelationshipStatus";
import { Text } from "../../../../../design/text";
import { CreateMatterForm } from "../../../../../models/CreateMatterForm";

const OnboardingRelationshipStatusStep: React.FC<{
  formData: Omit<
    CreateMatterForm,
    "_id" | "createdAt" | "updatedAt" | "createdById" | "updatedById" | "status"
  >;
  setFormData: React.Dispatch<
    React.SetStateAction<
      Omit<
        CreateMatterForm,
        | "_id"
        | "createdAt"
        | "updatedAt"
        | "createdById"
        | "updatedById"
        | "status"
      >
    >
  >;
  onBack: () => void;
  onStepComplete: () => void;
}> = ({ onBack, onStepComplete, formData, setFormData }) => {
  const handleSubmit = (e: React.FormEvent) => {
    onStepComplete();
  };

  return (
    <OnboardingContainer title={"Marriage Status"}>
      <>
        <Text>Tell us about your current marriage status.</Text>
        <form onSubmit={handleSubmit} className="space-y-6">
          <Field>
            <Label>What best describes your situation?</Label>
            <Select
              value={formData.relationshipDetails?.relationshipStatus ?? ""}
              onChange={(e) => {
                setFormData({
                  ...formData,
                  relationshipDetails: {
                    ...formData.relationshipDetails,
                    relationshipStatus: e.target.value as RelationshipStatus,
                  },
                });
              }}
            >
              <option value="" disabled>
                Select an option
              </option>
              {Object.entries(relationshipStatusArray).map(([key, value]) => (
                <option key={key} value={key}>
                  {value}
                </option>
              ))}
            </Select>
          </Field>
          <div className="flex items-end w-full mt-8 space-x-4">
            <Button plain type="button" onClick={onBack}>
              Back
            </Button>
            <Button
              type="submit"
              className="w-full"
              disabled={!formData.relationshipDetails?.relationshipStatus}
            >
              Continue
            </Button>
          </div>
        </form>
      </>
    </OnboardingContainer>
  );
};

export default OnboardingRelationshipStatusStep;
